import { WorkRequestResponseType } from '@commenda/types/src/work-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useWorkRequestModified<T>(
  workRequestId: string,
  token?: string | undefined
): {
  data: WorkRequestResponseType & { requestData: T };
  error: unknown;
  mutate: KeyedMutator<unknown>;
} {
  const {
    data,
    error,
    mutate,
  }: {
    data: WorkRequestResponseType & { requestData: T };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `workRequest/${workRequestId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
